export const GetLayerFieldService = Symbol('GetLayerFieldService');
